/*-----------------------------------------------------------------
- Accountant Locales
-----------------------------------------------------------------*/
export default {};
